import * as React from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import clsx from 'clsx';
import Grid from "@material-ui/core/Grid/Grid";
import { BrowserRouter as Router, Link as RouterLink } from "react-router-dom"
import {serverRootUrl} from "../../config";

const useStyles = makeStyles((theme) => ({
    index: {
        paddingTop: '0!important',
    },
    indexFirst: {
        paddingLeft: '0!important',
    },
    indexMid: {
        paddingLeft: '6px!important',
    },
    indexLast: {
        paddingRight: '0!important',
    },
    item: {
        position: 'relative',
        backgroundColor: '#ccc',
        //opacity: .1,
        //transition: 'visibility 0s, opacity 0.5s linear',
        '&::after': {
            boxSizing: 'inherit',
            content: '""',
            position: 'absolute',
            borderBottom: '2px solid transparent',
            width: '0',
            height: 2,
            bottom: 0,
            left: 0,
        },
        '&:hover': {
            '&::after': {
                width: '100%',
                height: 2,
                borderBottomColor: '#3849a4',
                transition: 'width 0.15s ease-out, height 0.15s ease-out 0.15s'
            },
        }
    },
    h3: {
        position: 'absolute',
        top: 0,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        wcolor: '#fff',
        color: '#000',
        fontWeight: 'normal',
        margin: '7px 0 0 10px',
    },
    h3Big: {
        fontSize: '1.4rem',
        letterSpacing: '.09rem'
    },
    h3Small: {
        fontSize: '1.2rem',
        letterSpacing: '.08rem',
    },
    header: {
        position: 'absolute',
        top: 0,
        wbackgroundColor: '#3849a4',
        backgroundColor: '#fff',
        borderTop: '1px dashed #ccc',
        borderLeft: '1px dashed #ccc',
        borderRight: '1px dashed #ccc',
        width: 'calc(100% - 2px)',

    },
    headerBig: {
        height: 40,
    },
    headerSmall: {
        height: 35,
    },
    price: {
        position: 'absolute',
        top: 0,
        right: 10,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        wcolor: '#fff',
        color: '#000',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        paddingLeft: '10px'
    },
    priceBig: {
        margin: '10px 0 0 0',
    },
    priceSmall: {
        margin: '7px 0 0 0',
    },
    options: {
        position: 'absolute',
        bottom: 0,
        height: 32,
        width: '100%',
        backgroundColor: '#fafafa',
        opacity: .95,
    },
    option: {
        position: 'absolute',
        bottom: 0,
        height: 32,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '.9rem'
    },
    optionValue: {
        position: 'absolute',
        height: 23,
        paddingTop: 9,
        paddingLeft: 10,
        whiteSpace: 'nowrap',
        overflow: 'hidden',

    },
    year: {
        left: 0,
    },
    link: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: '#415ae3'
    },
    comingSoon: {
        position: 'absolute',
        width: 'auto',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        color: '#fff',
        top: 'calc(50% - 18px)',
        left: 'calc(50% - 47px)',
        textAlign: 'center',
        cursor: 'pointer'
    }
}));

export function Item(props) {

    const classes = useStyles();

    const item = props.item;
    const isMobile = props.isMobile;

    const city = '';
    let title = '';
    const alt = '';
    const url = item.url;

    let className = 'Mid';

    switch (props.size) {
        case 'xxxl':
            className = (props.index+1) % 3 === 0 ? 'Last' : props.index % 3 === 0 ? 'First' : 'Mid';
            break;
        case 'xxl':

            break;
        default:
            break;

    }

    let isBig = props.cellW >= 350;

    console.log('props.', props)

    return <Grid item sm={props.span} className={classes.index}>
        <div className={classes.item} style={{
            width: props.cellW+'px',
            height: props.cellH+'px',
        }}>
                <a className={classes.link} href={url}>
                    <img className={classes.image} width={props.cellW} height={props.cellH}
                        src={serverRootUrl + item.image} alt={props.type} title={props.type}/></a>
            <div className={classes.options}></div>
            <div className={clsx(classes.option, classes.year)}>
                <div className={classes.optionValue}>
                    <b>{props.type}</b>
                </div>
            </div>
        </div>
    </Grid>;
}